import React, { useState, useEffect } from 'react'

import { Message, Panel, Row } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanel from '../../ButtonPanel'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import EditFormListWidget from '../dynamicForm/EditFormListWidget'
import ViewFormListWidget from '../dynamicForm/ViewFormListWidget'
import SettingEditFormListWidget from '../dynamicForm/SettingEditFormListWidget'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { cloneDeep, isEmpty, map } from 'lodash-es'
import InputForm from '../../../components/forms/input/InputForm'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import HTMLWidget from '../../HTMLWidget'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import { setAlertMessage } from '../../../utils/messageUtil'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { createDynamicListReq, setValueDynamicToReq } from '../../../utils/dynamicListReq'
import { saveFormProjectObjectiveOutcomeIndicator } from '../../../redux/actions/subProjectProposal'
import { doneLoading, startLoading } from '../../../utils/loading'
import CustomAlertMessage from '../../CustomAlertMessage'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'

export default function ProjectObjectiveOutcomeIndicatorWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props

  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [notiMsg, setNotiMsg] = useState()
  const [formSchema, setFormSchema] = useState(props.schema)
  //const [tempSchema, setTempSchema] = useState(props.schema)

  const [objectives, setObjectives] = useState([])
  const [newObjectives, setNewObjectives] = useState([])
  const [newObjectiveIndex, setNewObjectiveIndex] = useState(0)
  const [newOutcomeIndex, setNewOutcomeIndex] = useState(new Map())
  const [isRefash, setIsRefash] = useState(false)

  const [objectiveError, setObjectiveError] = useState([])
  const [outComeError, setOutComeError] = useState([])

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  useEffect(() => {
    setObjectives(props.schema?.objectives || [])
    //setNewObjectives(props.schema?.newObjectives || [])
  }, [props.schema])

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveFormProjectObjectiveOutcomeIndicator(subProjectId, request)
      if (response) {
        setFormSchema(response)
        setObjectives(response.objectives || [])
        setNewOutcomeIndex(new Map())
        setAlertMessage('success', SAVE_SUCCESS_MSG, setNotiMsg)
        onRefash()
        scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG, setNotiMsg)
      }
    } catch (e) {
      // console.log('error', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG, setNotiMsg)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)
    let newObjectives = objectives?.filter((e) => isEmpty(e.refId)) || [] //cloneDeep(objectives)
    let tempObjectives = objectives?.filter((e) => !isEmpty(e.refId)) || [] //cloneDeep(objectives)

    let newObj = objectives.filter((e) => e.id.startsWith('NEW_') && e.newOutcomes?.length < 1)
    let newOut = objectives.filter(
      (e) =>
        e.newOutcomes?.length > 0 &&
        e.newOutcomes.filter((out) => data[`newObjects:${out.id}`]?.length < 1).length > 0
    )

    //console.log('newObj : ', newObj)
    //console.log('newOut : ', newOut)

    if (newObj?.length > 0 || newOut?.length > 0) {
      let datas = []
      newObj?.forEach((e) => {
        datas.push(e.id)
      })
      setObjectiveError(datas)

      let outDatas = []
      newOut?.forEach((e) => {
        e.newOutcomes
          ?.filter((out) => out.newIndicators?.length < 1)
          ?.forEach((ot) => {
            outDatas.push(ot.id)
          })
      })

      setOutComeError(outDatas)
    } else {
      var templateValues = []

      tempObjectives?.forEach((item) => {
        var outcomes = []

        item.outcomes?.forEach((oc) => {
          let indicators = setValueDynamicToReq(oc?.indicators, data)

          /*var indicators = []
          oc?.indicators.forEach((ic) => {
            if (ic.resultType == '1' || ic.resultType == '3') {
              indicators.push({
                refId: ic.id,
                result: data[`${ic.id}`] || null,
              })
            }

            ic.moreInputs?.forEach((oi) => {
              if (oi.resultType == '1' || oi.resultType == '3') {
                indicators.push({
                  refId: oi.id,
                  result: data[`${oi.id}`] || null,
                })
              }
            })
          })*/

          let newIndicators = createDynamicListReq(
            data[`newObjects:${oc.id}`],
            data[`newObjectsValuesName:${oc.id}`]
          )

          outcomes.push({
            //id : oc.id,
            refId: oc.id,
            outcomeName: oc.outcome,
            indicators: indicators,
            newIndicators: newIndicators,
          })
        })

        item.newOutcomes?.forEach((noc) => {
          let newIndicators = createDynamicListReq(
            data[`newObjects:${noc.id}`],
            data[`newObjectsValuesName:${noc.id}`]
          )

          outcomes.push({
            id: noc.id,
            //refId: noc.id,
            outcomeName: data[`${formSchema.inputFrom.outcome.name}:${noc.id}`] || null,
            indicators: [],
            newIndicators: newIndicators,
          })
        })

        templateValues.push({
          //id: item.id,
          refId: item.id,
          outcomes: outcomes,
        })
      })

      newObjectives?.forEach((item) => {
        //var objectiveValue = data[`${formSchema.inputFrom.objective.name}:${item.id}`]

        item.objective = data[`${formSchema.inputFrom.objective.name}:${item.id}`] || null
        item.note = data[`${formSchema.inputFrom?.objectiveNote?.name}:${item.id}`] || null

        item.newOutcomes?.forEach((outcome) => {
          outcome.outcome = data[`${formSchema.inputFrom.outcome.name}:${outcome.id}`] || null

          let indicaor = createDynamicListReq(
            data[`newObjects:${outcome.id}`],
            data[`newObjectsValuesName:${outcome.id}`]
          )

          outcome.newIndicators = indicaor
        })
        // console.log('objective : ', objective)
      })

      let request = {
        id: formSchema.id,
        templateValues: templateValues,
        values: newObjectives,
      }

      //console.log('request : ', JSON.stringify(request))

      handleSave(request)
    }
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  const onAddObjective = () => {
    let newObjectives = cloneDeep(objectives)
    newObjectives.push({
      id: 'NEW_' + (newObjectiveIndex + 1),
      header: 'วัตถุประสงค์',
      objective: '',
      newOutcomes: [],
    })

    setNewObjectiveIndex(newObjectiveIndex + 1)

    setObjectives(newObjectives)
  }

  const onRemoveObjective = (objectiveIndex) => {
    let newObjectives = cloneDeep(objectives)
    newObjectives.splice(objectiveIndex, 1)
    setObjectives(newObjectives)
  }

  const onAddOutcome = (objectiveIndex) => {
    let newObjectives = cloneDeep(objectives)
    let outcomeIndex = cloneDeep(newOutcomeIndex) || new Map()

    let objectiveId = newObjectives[objectiveIndex]?.id
    let idIndex = outcomeIndex.get(objectiveId) || 0

    newObjectives[objectiveIndex].newOutcomes?.push({
      id: 'NEW_:' + objectiveId + ':' + (idIndex + 1),
      header: 'ผลลัพธ์',
      outcome: '',
      newIndicators: [],
    })

    outcomeIndex.set(objectiveId, idIndex + 1)

    setNewOutcomeIndex(outcomeIndex)
    setObjectives(newObjectives)
  }

  const onRemoveOutcome = (objectiveIndex, outcoumIndex) => {
    let newObjectives = cloneDeep(objectives)
    newObjectives[objectiveIndex].newOutcomes.splice(outcoumIndex, 1)
    setObjectives(newObjectives)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {isLoading && <OverlayLoader />}

      {/* <WarningMessage message={formSchema?.feedbackBySubject} /> */}
      {!isRefash && (
        <>
          {isEdit && showCommandButton ? (
            <>
              {formSchema.description && (
                <Row style={{ marginBottom: 10 }}>
                  <CustomAlertMessage contents={formSchema.description} />
                </Row>
              )}
              {objectives?.map((e, index) => {
                return (
                  <Panel
                    header={e.header + (objectives?.length > 1 ? ' ที่ ' + (index + 1) : '')}
                    collapsible
                    defaultExpanded
                    bordered
                    style={{ marginBottom: 20 }}
                  >
                    <div style={{ marginTop: -10, marginBottom: 10 }}>
                      {!e.refId ? (
                        <InputForm
                          schema={formSchema.inputFrom.objective}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          value={e.objective}
                          name={`${formSchema.inputFrom.objective.name}:${e.id}`}
                        />
                      ) : (
                        <div style={{ marginTop: -10, marginBottom: 10 }}>{e.objective}</div>
                      )}
                    </div>
                    {e.outcomes?.map((se, subIndex) => {
                      return (
                        <Panel
                          header={'ผลลัพธ์ : ' + se.outcome}
                          style={{ marginBottom: 10 }}
                          // collapsible
                          // defaultExpanded
                          bordered
                        >
                          <div style={{ marginTop: -10, marginBottom: 10 }}>
                            <Panel
                              header={'ตัวชี้วัด'}
                              collapsible
                              defaultExpanded
                              bordered
                              style={{ marginBottom: 20 }}
                            >
                              <EditFormListWidget
                                schema={se}
                                register={register}
                                Controller={Controller}
                                control={control}
                                errors={errors}
                                setValue={setValue}
                                clearErrors={clearErrors}
                                setLoading={setIsLoading}
                                // header={'ตัวชี้วัด'}
                                // collapsible
                                // defaultExpanded
                                // bordered
                                key={se.id}
                                values={se.indicators || []}
                                objectsValuesName={`objectsValuesName:${se.id}`}
                              />

                              {/* <div style={{ marginBottom: 10 }}>{se.outcome}</div> */}

                              <div style={{ marginTop: -20, marginBottom: -30 }}>
                                <SettingEditFormListWidget
                                  hideDescription
                                  schema={formSchema}
                                  register={register}
                                  Controller={Controller}
                                  control={control}
                                  errors={errors}
                                  setValue={setValue}
                                  clearErrors={clearErrors}
                                  setLoading={setIsLoading}
                                  inputForm={formSchema.inputFrom}
                                  enableAddSub={false}
                                  datas={se.newIndicators || []}
                                  buttonText={'ตัวชี้วัด'}
                                  //key={se.id}
                                  hideDescriptionSetting={true}
                                  inputMode={true}
                                  newObjectsName={`newObjects:${se.id}`}
                                  newObjectsValuesName={`newObjectsValuesName:${se.id}`}
                                />
                              </div>
                            </Panel>
                          </div>
                        </Panel>
                      )
                    })}

                    {e.newOutcomes?.map((se, subIndex) => {
                      return (
                        <Panel
                          header={'ผลลัพธ์ : ' + se.outcome}
                          style={{ marginBottom: 10 }}
                          // collapsible
                          // defaultExpanded
                          bordered
                        >
                          <div style={{ marginTop: -10, marginBottom: 10 }}>
                            {formSchema?.inputFrom?.outcome && (
                              <div style={{ marginBottom: 20 }}>
                                <InputForm
                                  schema={formSchema.inputFrom.outcome}
                                  register={register}
                                  Controller={Controller}
                                  control={control}
                                  errors={errors}
                                  setValue={setValue}
                                  clearErrors={clearErrors}
                                  value={se.outcome}
                                  name={`${formSchema.inputFrom.outcome.name}:${se.id}`}
                                />
                              </div>
                            )}

                            {/* <div style={{ marginBottom: 10 }}>{se.outcome}</div> */}
                            <Panel
                              header={'ตัวชี้วัด'}
                              collapsible
                              defaultExpanded
                              bordered
                              style={{ marginBottom: 20 }}
                            >
                              <div style={{ marginTop: -20, marginBottom: -30 }}>
                                <SettingEditFormListWidget
                                  hideDescription
                                  schema={formSchema}
                                  register={register}
                                  Controller={Controller}
                                  control={control}
                                  errors={errors}
                                  setValue={setValue}
                                  clearErrors={clearErrors}
                                  setLoading={setIsLoading}
                                  inputForm={formSchema.inputFrom}
                                  enableAddSub={false}
                                  datas={se.newIndicators || []}
                                  buttonText={'ตัวชี้วัด'}
                                  //key={se.id}
                                  inputMode={true}
                                  required={outComeError?.find((er) => er == se.id) != null}
                                  newObjectsName={`newObjects:${se.id}`}
                                  newObjectsValuesName={`newObjectsValuesName:${se.id}`}
                                />
                              </div>
                            </Panel>
                          </div>
                          <CancelButton
                            icon="trash-o"
                            children={`ลบผลลัพธ์`}
                            onClick={() => {
                              onRemoveOutcome(index, subIndex)
                            }}
                          />
                        </Panel>
                      )
                    })}

                    {e.newOutcomes?.length < 1 && objectiveError?.find((er) => er == e.id) && (
                      <>
                        <ErrorMessage
                          error={{ message: 'กรุณาเพิ่มผลลัพธ์' }}
                          style={{ marginBottom: 10 }}
                        />
                      </>
                    )}
                    <SaveButton
                      icon="plus"
                      children={`เพิ่มผลลัพธ์`}
                      onClick={() => {
                        onAddOutcome(index)
                      }}
                    />
                    {e.note && (
                      <Message
                        showIcon
                        type="info"
                        style={{ marginTop: 20 }}
                        description={<HTMLWidget data={e.note} />}
                      />
                    )}
                    <br />
                    {!e.unableDelete && (
                      <CancelButton
                        icon="trash-o"
                        children={`ลบวัตถุประสงค์`}
                        onClick={() => {
                          onRemoveObjective(index)
                        }}
                      />
                    )}
                  </Panel>
                )
              })}

              <SaveButton
                icon="plus"
                children={`เพิ่มวัตถุประสงค์`}
                onClick={() => {
                  onAddObjective()
                }}
              />
            </>
          ) : (
            <>
              {formSchema?.objectives?.map((e, index) => {
                return (
                  <Panel
                    header={
                      e.header + (formSchema?.objectives?.length > 1 ? ' ที่ ' + (index + 1) : '')
                    }
                    collapsible
                    defaultExpanded
                    bordered
                    style={{ marginBottom: 20 }}
                  >
                    <div style={{ marginTop: -10, marginBottom: 10 }}>{e.objective}</div>
                    {e.outcomes?.map((se) => {
                      return (
                        <Panel
                          header={'ผลลัพธ์ : ' + se.outcome}
                          style={{ marginBottom: 10 }}
                          // collapsible
                          // defaultExpanded
                          bordered
                        >
                          <div style={{ marginTop: -10, marginBottom: 10 }}>
                            <Panel
                              header={'ตัวชี้วัด'}
                              collapsible
                              defaultExpanded
                              bordered
                              style={{ marginBottom: 20 }}
                            >
                              <ViewFormListWidget
                                style={{ marginTop: -20 }}
                                prefix={'- '}
                                objects={[...(se.indicators || []), ...(se.newIndicators || [])]}
                              />
                            </Panel>
                          </div>
                        </Panel>
                      )
                    })}
                    {e.newOutcomes?.map((se) => {
                      return (
                        <Panel
                          header={'ผลลัพธ์ : ' + se.outcome}
                          style={{ marginBottom: 10 }}
                          // collapsible
                          // defaultExpanded
                          bordered
                        >
                          <div style={{ marginTop: -10, marginBottom: 10 }}>
                            <Panel
                              header={'ตัวชี้วัด'}
                              collapsible
                              defaultExpanded
                              bordered
                              style={{ marginBottom: 20 }}
                            >
                              <ViewFormListWidget
                                style={{ marginTop: -20 }}
                                prefix={'- '}
                                objects={[...(se.indicators || []), ...(se.newIndicators || [])]}
                              />
                            </Panel>
                          </div>
                        </Panel>
                      )
                    })}
                  </Panel>
                )
              })}
            </>
          )}
        </>
      )}

      {formSchema.note && (
        <Message
          showIcon
          type="info"
          style={{ marginTop: 20 }}
          description={<HTMLWidget data={formSchema.note} />}
        />
      )}

      {showCommandButton && !mode && (
        <div className="right">
          <hr />
          {notiMsg && (
            <Message
              closable
              showIcon
              type={notiMsg.type}
              description={notiMsg.msg}
              onClose={() => setNotiMsg('')}
              style={{ marginBottom: 10 }}
              className="left"
            />
          )}

          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || formSchema.header}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              setObjectives(formSchema?.objectives || [])
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </div>
      )}
    </Panel>
  )
}
